import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../src/components/Layout';
import { getHeader, getFooter, getAllRetailerCampaignData } from '../src/adapters/contentful.adapter';
import RetailerPromotion from '../src/components/RetailerPromotion/Retailerpromotion';

const RetailerCampaign = (props) => {
    const { header, footer, sampleData, pageInfo } = props;
    return (

        <div>
            <Layout header={header} footer={footer} pageInfo={pageInfo}>
                <div className="content-wrapper">
                    <RetailerPromotion sampleData={sampleData} />
                    <div id="mw-campaign">get-my-free-sample</div>
                </div>
            </Layout>
        </div>
    );
};
RetailerCampaign.getInitialProps = async () => {
    const header = await getHeader();
    const footer = await getFooter();
    const sampleData = await getAllRetailerCampaignData();
    return {

        header,
        footer,
        sampleData,
        pageInfo: { breadcrumbsTitle: 'ウィスパーのお得な情報',
            title: 'ウィスパーのお得な情報',
            description:
     'ウィスパーが今ならウエルシアとドラッグイレブンでお得。UI（尿もれ）に関する記事やあなたにぴったりの商品がわかる商品診断もご利用いただけます。',
            url: '/ウィスパーのお得な情報',
            ogTitle: 'ウィスパーのお得な情報',
            ogType: 'website',
            ogDescription:
     'ウィスパーが今ならウエルシアとドラッグイレブンでお得。UI（尿もれ）に関する記事やあなたにぴったりの商品がわかる商品診断もご利用いただけます。',
            ogImage:
     { url:
        'https://images.ctfassets.net/8g0fievzqg8k/1xYSc0d2UTlal28HNKCF5S/f2454808263615cb9d7944c6025f6137/KOI_OPG_kv.jpg',
     width: 1201,
     height: 631,
     contentType: 'image/jpeg' },
            canonicals: { items: [{ canonical: '/campaign/whisper-retailer-promotion/' }] } },
    };
};
RetailerCampaign.propTypes = {
    footer: PropTypes.object,
    header: PropTypes.object,
    sampleData: PropTypes.object,
    pageInfo: PropTypes.object,
};
export default RetailerCampaign;
